import { NamedUserUID } from "@/app/@types/enums";
import { User } from "@/app/@types/user";

// Accounts that get the floating POS quick-charge button ON by default.
// Everyone else with payments enabled can opt in via the card reader setting.
const POS_TRIGGER_DEFAULT_ON: string[] = [
  NamedUserUID.Mesquite,
  NamedUserUID.CROCKETTS,
];

// True only for a tenant with a live Stripe Connect account that can take
// charges. Both flags are written by the account webhook: connected once an
// account exists, enabled mirroring Stripe's charges_enabled. This is the
// gate for anything that actually charges a card. The MM_PAYMENTS_ENABLED
// feature flag is a rollout switch that is on for every signed-in tenant and
// must not be used on its own for this.
export const canChargeCards = (user: User): boolean =>
  !!user.settings.mmPaymentsEnabled && !!user.settings.mmPaymentsConnected;

export const isPosTriggerEnabled = (user: User): boolean => {
  if (!user.settings.mmPaymentsEnabled) return false;

  const setting = user.settings.posTriggerEnabled;
  if (POS_TRIGGER_DEFAULT_ON.includes(user.uid)) {
    // Default on — hidden only if explicitly turned off.
    return setting !== false;
  }
  // Default off — shown only if explicitly turned on.
  return setting === true;
};
